export const styles = {
  row: {
    padding: '4px 16px',
    display: 'flex',
    justifyContent: 'space-between',
  },
  col: (align = 'center') => ({
    padding: 0,
    display: 'flex',
    justifyContent: align,
  }),
  contentWrapper: {
    display: 'flex',
    alignItems: 'center',
  },
  iconWrapper: {
    marginRight: 8,
    height: 25,
  },
  label: {
    color: '#707087',
    fontSize: 14,
    fontWeight: 700,
  },
}
